<template>
  <div class="AllBox">
    <van-sticky>
      <van-nav-bar title="我的群聊" safe-area-inset-top @click-left="onClickLeft" fixed>
        <template #right>
          <img src="../../assets/chat/chat_search.png" alt="" @click="goGroupSearch" class="right-lr">
        </template>
      </van-nav-bar>
    </van-sticky>

    <!-- <h1 @click="onCreateTeam">创建群聊</h1> -->
    <!-- <h1>搜索群聊</h1> -->
    <div class="mainBox">
      <ul>
        <li v-for="(item, i) in state.sessions" :key="i + '-teams'" @click="handleSessions(item)" :class="[item.isTop?'topStyles':'']">
          <div class="chatFlex">
            <img :src="item.avatar" />
            <img src="../../assets/chat/chat_authority01.png" alt="" class="authority">
            <div class="infoMid">
              <h3 class="name">{{ item.name }}</h3>
              <!-- 收到了@消息 -->
              
              <p :class="'at'+item.to">
                <span :class="'atMsg'+item.to"></span>
                      {{ getSessionLastMsg(item.to)}}
              </p>
            </div>
          </div>

          <div class="timeBox">
            <p>{{ getSessionTime(item.to) }}</p>
            <!-- <div class="unreadDiv" :class="item.to" > -->
              <!-- <span>{{ getSessionUnread(item.to) }}</span> -->
              <van-badge :content="getSessionUnread(item.to)" color="#FF6666" max="99">
                <div class="child" />
              </van-badge>
            <!-- </div> -->
          </div>
        </li>
      </ul>

          <!-- 缺失页 -->
        <div class="noData" v-if="state.sessions.length==0">
          <img src="../../assets/chat/chat_noGroup.png" alt="">
          <p>目前还没加入群聊哦，快加入群聊聊天吧！</p>
        </div>
            
        <!-- 遮罩层 -->
        <van-overlay :show="state.maskShow">
          <van-loading type="spinner" color="#664FC3" class="blockLoad" size="24px"/>
        </van-overlay>
    </div>
  </div>
</template>
    
<script>
import { onMounted, reactive,computed,onActivated,onDeactivated} from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import SDK, { NIM } from "@yxim/nim-web-sdk";
import touxiang from "@/assets/touxiang.png";
import dayjs from "dayjs";
import { on } from "events";
import { dateHM }from '@/utils/date'
import { stat } from "fs";
import { getInfo } from "../../api/user";
import {
	getQueryString
} from '@/utils/location'
export default {
  name: "sessionsName",
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      uid: "",
      noimg: touxiang,
      notice: false,
      top: false,
      teamData: {},
      nim: null,
      userID: "166419",
      teamId: "",
      inputText: "",
      myMap: new Map(), //创建map对象
      // router: useRouter(),
      sessions: [], //会话列表
      loaclTeams: [], //缓存我的群聊
      dataInfo: {
        myInfo: {},
        msgs: [],
        users: [],
        teamMembers: [],
        teams: [],
      },
      userRead: 0,
      // 置顶群组
      stickTopSessions: [],
      // 汇总消息未读数
      totalUnread:0,
      // 是否被@
      atMsgFlag:false,

      // 退出群ID
      quitTeamId:'',

      // 是否显示遮罩层
      maskShow:true,

    });

    // 利用计算属性决定是否显示未读数
    // const unread = computed(() => {
    //   return state.userRead > 0 ? state.userRead : "";
    // });


    const judjeObj = (obj) => {
      var isobj = false;
      try {
        JSON.parse(obj);
        // console.log(JSON.stringify(obj) + '判断点点滴滴')
        isobj = true;
      } catch (e) {
        // console.log('判断是否为有效的json对象--------',e);
        isobj = false;
      }
      return isobj;
    };
    //最新消息
    const getSessionLastMsg = (id) => {

      var obj = state.myMap.get(id);
      if (judjeObj(obj)) {

        let lastestMsg = JSON.parse(obj).lastMsg;

        // 如果lastMsg返回bull，说明撤回了一条消息
        if(lastestMsg==null){
          return '撤回了一条消息';
        }

        console.log('最新消息-------------------',lastestMsg)
        //自己被艾特了 @通知事件
        if(lastestMsg.custom){
          let appointFrom = lastestMsg.from;
          let appointTo = JSON.parse(lastestMsg.custom);
          // 去掉appointTo的第一个@和空格
          appointTo = appointTo.substring(1, appointTo.length).trim();
          // console.log('被艾特人的账号-------------------',appointTo)
          // console.log('当前用户的id-------------------',state.userID)
    
          // 如果appointTo和当前用户的id相同，就是我被指定了
          // if(appointTo==state.userID && appointFrom!=state.userID){
          if(appointTo==state.userID &&JSON.parse(obj).unread>0){
            // console.log('我被指定了-------------------')
            // 更改此条被@最新消息的样式
                setTimeout(() => {
                  if(document.getElementsByClassName('atMsg'+id)[0]){
                    document.getElementsByClassName('atMsg'+id)[0].innerHTML = '[有人@了我]';
                    document.getElementsByClassName('atMsg'+id)[0].style.color = '#FF6666';
                  }
                }, 2);   
                // setTimeout(() => {
                //   if(document.getElementsByClassName('at'+id)[0]){
                //     console.log('需要被插入的元素-------------------',document.getElementsByClassName('at'+id)[0])
                //     document.getElementsByClassName('at'+id)[0].innerHTML = '<span class="atMsg'+id+'" style="color:#ff6666">[有人@了我]</span>'+lastestMsg.fromNick + ':'+lastestMsg.text;
                //   }
                // }, 2);
          }else{
            setTimeout(() => {
              if(document.getElementsByClassName('atMsg'+id)[0]){
                document.getElementsByClassName('atMsg'+id)[0].innerHTML = '';
              }
            }, 2);
            return lastestMsg.fromNick + ':'+lastestMsg.text;
          }
        }

        if(lastestMsg.type == 'image'){
          return lastestMsg.fromNick + ':'+'[图片]';
        }else if(lastestMsg.type == "notification"){
          // return JSON.parse(obj).lastMsg.fromNick + ':'+'[通知]';
          if(lastestMsg.attach&&lastestMsg.attach.type=='addTeamManagers'){
            return '[通知]：'+lastestMsg.attach.users[0].nick + '成为管理员';
          }
          if(lastestMsg.attach&&lastestMsg.attach.type=="passTeamApply"){
            return '[通知]：'+lastestMsg.fromNick + '加入了群聊';
          }
          return '[通知]';
        }
        return lastestMsg.fromNick + ':'+lastestMsg.text;
      } else {
        return "暂无消息";
      }
    };
    //未读数
    const getSessionUnread = (id) => {
      

      var obj = state.myMap.get(id);
      if (judjeObj(obj)) {

        if(JSON.stringify(JSON.parse(obj).unread)==0){
        // 移除未读数
        setTimeout(() => {
          if(document.getElementsByClassName(id)[0]){
            document.getElementsByClassName(id)[0].style.display = 'none';
          }
        }, 2);
        }else{
           setTimeout(() => {
          if(document.getElementsByClassName(id)[0]){
            document.getElementsByClassName(id)[0].style.display = 'block';
          }

        }, 2);
          return JSON.stringify(JSON.parse(obj).unread)
        }} else {
        return "0";
      }
      
        
    };
    //最后会话时间
    const getSessionTime = (id) => {
      var obj = state.myMap.get(id);
      if (judjeObj(obj)) {
        var time = JSON.stringify(JSON.parse(obj).updateTime);
        // 将获取到的毫秒时间戳转换为时间

        return dateHM(time/1000);
      } else {
        return "时间";
      }

    };
    const onClickLeft = () => {
      router.back();
    }

    const onTeams = (teams) => {
      // console.log("初始化收到群列表--------------", teams);

      // 合并群组
      state.dataInfo.teams = state.nim.mergeTeams(state.dataInfo.teams, teams);

      localStorage.setItem(state.userID, JSON.stringify(teams));
    };

    const onInvalidTeams = (teams) => {
      state.dataInfo.teams = state.nim.cutTeams(state.dataInfo.teams, teams);
      state.dataInfo.invalidTeams = state.nim.mergeTeams(
        state.dataInfo.invalidTeams,
        teams
      );
      refreshTeamsUI();
    };

    const onTeamMembers = (obj) => {
      console.log("收到群成员", obj);
      var teamId = obj.teamId;
      var members = obj.members;
      for (let index = 0; index < members.length; index++) {
        const element = members[index];
      }
      state.dataInfo.teamMembers = members;
      refreshTeamMembersUI();
      console.log("群成员总量" + JSON.stringify(state.dataInfo.teamMembers));
    };
    const onSyncTeamMembersDone = () => {
      console.log("同步群列表完成");
    };

    const updateLocalSessionDone = (error, obj) => {
      // console.log(error);
      // console.log(obj);
      console.log("更新本地会话" + (!error ? "成功" : "失败"));
    };

    const onSessions = (sessions) => {

      // console.log('初始化收到会话列表时，群的信息---------------',sessions)
      if(state.maskShow){
        state.maskShow = false;
      }


      sessions.forEach((item) => {
        // console.log('群名----------',item)
        if(!item.name){
            state.nim.getTeam({
              teamId: item.to,
              done: function (error, obj) {
              // console.log(error);
              // console.log('新增群------------------------------',obj);
              if (!error) {
                item.name = obj.name;
                item.avatar = obj.avatar;
                state.myMap.set(item.to, JSON.stringify(item));
              }
            }
          });
        }
      });


      // console.log('初始化收到会话列表时，本地群的信息---------------',state.loaclTeams)

      // 如果session的lastmsg为null，且session不存在ack字段，就不显示该会话
      sessions = sessions.filter((item) => {
        return item.lastMsg != null || item.ack != null;
      });

      // 更新置顶群的数据
      state.nim.getStickTopSessions({
        done:function(error, obj){
          // console.log('获取置顶群的数据-------------------',obj)
          // 给置顶群的数据添加头像和群名   -*-*-*-*-*-*--
          obj.forEach((item) => {
            state.dataInfo.teams.forEach((item2) => {
              if (item.to == item2.teamId) {
                item.name = item2.name;
                item.avatar = item2.avatar;
              }
            });
          });
          // 对置顶群进行排序
          obj.sort((a,b)=>{
            return  a.updateTime - b.updateTime
          })
          state.stickTopSessions = obj;
        }
      });


      // console.log("初始化收到会话列表---------------", sessions);
      // 重置消息未读数
      state.totalUnread = 0;

      // 过滤掉非群聊的会话
      sessions = sessions.filter((item) => {
        return item.scene == "team";
      });

      
      // 汇总消息未读数
      sessions.forEach((item) => {
        state.totalUnread += item.unread;
      });
      // console.log('汇总消息未读数------------------',state.totalUnread)

      //将消息未读数传出去,
      // store.commit('SET_UNREAD',state.totalUnread) 

      // 按照时间戳排序
      sessions.sort((a, b) => {
        return b.updateTime - a.updateTime;
      });

      // console.log('添加头像和群名，群的信息---------------',sessions)

      //把头像和群名添加到会话列表信息  -*-*-*-*-*-*-*-*-*-
      sessions.forEach((item) => {
        state.dataInfo.teams.forEach((item2) => {
          if (item.to == item2.teamId) {
            item.name = item2.name;
            item.avatar = item2.avatar;
          }
        });
      }); 

      // 将sessions中的群聊和本地群聊进行对比，如果本地群聊中有，就将本地群聊的头像和群名赋值给sessions
     setTimeout(() => {
      for(let i = 0; i < sessions.length; i++){
        const element = sessions[i];
        // console.log('本地存储的群聊信息--------------',state.loaclTeams)
       if(state.loaclTeams){
          for(let j = 0; j < state.loaclTeams.length; j++){
            const element2 = state.loaclTeams[j];
            if(element.to == element2.teamId){
              element.name = element2.name;
              element.avatar = element2.avatar;
            }
          } 
        }
      }
     },1000)

      setTimeout(() => {
        // console.log('初始化收到会话列表时，置顶群的信息---------------',state.stickTopSessions)

        // 按照时间戳对置顶群进行排序
        state.stickTopSessions.sort((a,b)=>{
          return  a.updateTime - b.updateTime
        })

        if(state.stickTopSessions.length>0){
          for(let i = 0; i < state.stickTopSessions.length; i++){
            const element = state.stickTopSessions[i];
            for(let j = 0; j < sessions.length; j++){
              const element2 = sessions[j];
              if(element.to == element2.to){
                sessions.splice(j,1);
                sessions.unshift(element);
              }
            }
          }
          // console.log('置顶的群插入在sessions数据最上方-------------------',sessions)
          state.sessions=sessions
        }else{
          state.sessions=sessions
        }
      }, 0);

      // state.maskShow = false;

      updateSessionsUI();

      for (let index = 0; index < sessions.length; index++) {
        const element = sessions[index];
        state.myMap.set(element.to, JSON.stringify(element));
      }
    };

    const getTeamDone = (error, obj) => {
      // console.log("收到系统通知未读数", error);
      // console.log("获取群对象", obj);
      state.teamData = obj;
      state.myMap.set(obj.teamId, obj);
    };

    const onUpdateSession = (session) => {
      console.log("会话更新了", session);

      state.sessions = state.nim.mergeSessions(state.sessions, session);
      
      console.log('更新会话列表时，群的信息---------------',state.sessions)

      onSessions(state.sessions);             
      updateSessionsUI();
    };
    const updateSessionsUI = () => {
      // 刷新界面
      // console.log("界面刷新了-------------");
    };
    // const getLocalSessionsByMsgTypeDone = (error, obj) => {
    //   console.log("获取会话列表" + (!error ? "成功" : "失败"), error, obj);
    //   if (!error) {
    //     onSessions(obj.sessions);       
    //   }
    // };
    // const getSessionsWithMoreRoamingDone = (error, obj) => {
    //   console.log("漫游会话列表" + (!error ? "成功" : "失败"), error, obj);
    // };
    // const getTeamMsgReadAccountsDone = (error, obj, content) => {
    //   console.log(
    //     "获取群组消息已读" + (!error ? "成功" : "失败") + obj + content
    //   );
    //   /* content.teamMsgReceipt 为
    //   idClient: "c7575fca32bf142787986e752fdeff6a",
    //   readAccounts: Array[],
    //   unreadAccounts: Array[]
    // */
    // };
    const getLocalSessionsDone = (error, obj) => {
      console.log(error);
      console.log(obj);
      // console.log("收到会话列表" + JSON.stringify(obj.sessions));
      // console.log("获取本地会话列表" , state.loaclTeams);
      // console.log("获取本地会话列表" + (!error ? "成功" : "失败"));
      if (!error) {
        // console.log("-------------------------调用了onsessions-------------------------");
        onSessions(obj.sessions);        
      }
    };

    // 会话列表点击
    const handleSessions = (item) => {
      // console.log('点击的会话信息-----------------------',item);
      // debugger
      router.push({
        path: "/simpleChat",
        // name: "simpleChat",
        query: {
          groupId: item.to,
          type: "team",
          name: item.name,
          avatar: item.avatar,
        },
      });
    };
    const goGroupSearch = () => {
      router.push({
        path: "/groupSearch",
      });
    };

    const onStickTopSessions = (obj) => {
      // 给置顶群的数据添加头像和群名
      obj.forEach((item) => {
        state.dataInfo.teams.forEach((item2) => {
          if (item.to == item2.teamId) {
            item.name = item2.name;
            item.avatar = item2.avatar;
          }
        });
      });
      //根据时间对置顶群排序
      // obj.sort((a, b) => {
      //   return b.updateTime - a.updateTime;
      // });
      state.stickTopSessions = obj;

      // console.log('群组是否置顶的回调--------------',state.stickTopSessions);
    };


    onActivated(()=>{

      
        // 如果wyToken的值为null，直接拒绝执行
        if(!getQueryString('wyToken')||getQueryString('wyToken')=='null'){
          // console.log('传递的值为空---------',getQueryString('wyToken'))
          state.sessions=[];
          console.log(state.sessions)
          state.maskShow = false;
          return
        }else{
          state.maskShow = true;
        }
              
      window.JsBridge.showBottomTab();

        // 删除退出群聊的会话
        // delQuitTeam();

        // 获取用户ID
       state.uid=getQueryString('uid');
      //  console.log('传过来的用户id-------------------',state.uid)
      //  根据传过来的用户id获取用户信息
      getInfo(
        { uid:state.uid }
        ).then(res=>{
          // console.log(res)
          if(res.data.code==1){
            let data=res.data.data
            // console.log('用户信息接口返回的数据------------',data)
            state.userID=data.username;
            // 将用户信息存入vuex
            store.commit('SET_NAME',data.nicename)
            store.commit('SET_AVATAR',data.avatar)
            store.commit('SET_NAME',data.username)
            store.commit('SET_NICENAME',data.nicename)
            store.commit('SET_WYACCOUNT',data.username)
            store.commit('SET_ID',data.id)
          }
        })




      // console.log('onActivated执行了-------------------')
        //  将用户id 设置为当前用户
        // state.userID = store.state.id;
        // state.userID = store.state.wyAccount;
        // console.log('当前用户id-------------------',state.userID)

        window.scrollTo(0, 0);
        console.log("mounted");
        
        setTimeout(() => {
          //初始化IM
          state.nim = SDK.NIM.getInstance({
            // 初始化SDK
            debug: false,
            appKey: store.state.appKey,
            // account:store.state.wyAccount,
            // token: store.state.wyToken,

            account:store.state.wyAccount,
            token: getQueryString('wyToken'),

            debugLevel: "debug",
            db: false,
            syncSessionUnread: true,
            syncStickTopSessions: true,
            onteams:onTeams,
            // onteammembers: this.onTeamMembers,
            // onsyncteammembersdone: this.onSyncTeamMembersDone,
            onsessions: onSessions,
            onStickTopSessions:onStickTopSessions,
            onupdatesession: onUpdateSession,
          });
        }, 300);

        var loaclteamsJson = localStorage.getItem(state.userID);
        state.loaclTeams = JSON.parse(loaclteamsJson);
        // console.log('我的群聊列表-------------------', JSON.stringify(state.loaclTeams))
        
        //将网易云信的token存入vuex
        store.commit('SET_WYTOKEN',getQueryString('wyToken'))

        // setTimeout(() => {

        //   // state.nim.getLocalSessions({
        //   //   // lastSessionId: lastSessionId,
        //   //   limit: 100,
        //   //   done: getLocalSessionsDone,
        //   // });
        // }, 1000);

        // 初始话获取一次汇总的未读数
        // console.log('初始话获取一次汇总的未读数------------------',state.totalUnread)

        // 
        // console.log('本账号全部信息------------',store.state)
        // updateSessionsUI();
      })

      // 失活时清空会话列表
      // onDeactivated(()=>{
      //   state.sessions = [];
      //   state.stickTopSessions = [];
      // })

      // 加载动画
      // onMounted(() => {
      //   // console.log('onMounted执行了-------------------')

      // });

    return {
      state,
      judjeObj,
      // unread,
      // onStickTopSessions,
      goGroupSearch,
      getSessionLastMsg,
      getSessionUnread,
      onClickLeft,
      onTeams,
      onInvalidTeams,
      onTeamMembers,
      onSyncTeamMembersDone,
      updateLocalSessionDone,
      // onSessions,
      onUpdateSession,
      getTeamDone,
      updateSessionsUI,
      // getLocalSessionsByMsgTypeDone,
      // getSessionsWithMoreRoamingDone,
      // getTeamMsgReadAccountsDone,
      getLocalSessionsDone,
      handleSessions,
      getSessionTime
    }
  }
};
</script>
    
<style scoped="scoped">
.van-nav-bar{
  background-color: #fff;
}
.van-nav-bar__right img{
  width: 48px;
  height: 48px;
}
.AllBox {
  background-color: #fff;
    padding-top: calc(110px + constant(safe-area-inset-top));
    /* 适配安全区域 iOS < 11.2 */
    padding-top: calc(110px + env(safe-area-inset-top));
    /* 适配安全区域 iOS >= 11.2 */
}

.mainBox {
  /* height: 2000px; */
  min-height: 100vh;
  /* padding-top: 24px; */
  background-color: #fff;
  /* padding-top: 70px; */
}

.mainBox ul {
  /* background-color: #f8f8f8; */
  padding-bottom: 100px;
}

.mainBox ul li {
  background-color: #f7f7f7;
  margin: 24px 24px;
  padding: 24px;
  border-radius: 15px;
  display: flex;
  justify-content: space-between;
}

.chatFlex {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.chatFlex .infoMid .atMsg{
  color: #FF6666;
}

.chatFlex .authority {
  position: absolute;
  left: 80px;
  bottom: 0;
  height: 40px;
  width: 40px;
}

.chatFlex h3 {
  font-size: 28px;
  font-weight: bold;
  color: #333333;
  max-width: 406px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.chatFlex p {
  font-size: 24px;
  color: #999;
  margin-top: 15px;
  max-width: 494px;
  overflow: hidden;
  /* text-wrap:nowrap; */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
}

.mainBox ul li img {
  width: 116px;
  height: 116px;
  border-radius: 50%;
  margin-right: 24px;
}

.timeBox {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.timeBox p {
  color: #999999;
  font-size: 22px;
  margin-bottom: 18px;
}

.unreadDiv {
  color: #ffffff;
  font-size: 20px;
  background-color: #ff6666;
  border-radius: 15px;
  padding: 2px 10px;
}

.unreadDiv span {
  border-radius: 15px;
  height: 30px;
}
.topStyles{
  background-color: rgba(156, 133, 251, .15)!important;
}

/* 消息通知 */
:deep(.van-badge){
  border-color:#FF6666;
}
.right-lr{
  width: 24px;
  height: 24px;
}

.noData{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: -50px;
  position: relative;
}
.noData img{
  width: 400px;
  height: 400px;
}
.noData p{
  color: #999999;
  font-size: 28px;
  position: absolute;
  bottom: 40px;
}
.van-overlay{
  background-color: #f7f7f7;
}
.blockLoad{
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
 .van-loading__spinner{
  color:#6D4EEB!important;
}
</style>